import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonService } from '../../services/common.service';

@Component({
  selector: 'app-confirm-ar-creation-popup',
  templateUrl: './confirm-ar-creation-popup.component.html',
  styleUrls: ['./confirm-ar-creation-popup.component.css'],
})
export class ConfirmARCreationPopup implements OnInit {

  constructor(
    public commonService: CommonService,
    public dialogRef: MatDialogRef<ConfirmARCreationPopup>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {}

  okButton(): void {
    this.dialogRef.close(true);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  copyLink(): void {
    const listener = (e: ClipboardEvent) => {
      e.clipboardData.setData('text/plain', (this.data.link));
      e.preventDefault();
    };

    document.addEventListener('copy', listener);
    document.execCommand('copy');
    document.removeEventListener('copy', listener);
    this.commonService.implementToast('link copied to clipboard successfully', 'Success');
  }
}
